<template>
  <div class="background" :style="'background-image: url(' + Background + ')'">
    <MarketplaceDesktop
      :listings="listings"
      :rarities="rarities"
      :artists="artists"
      @filterChanged="filterChanged"
      @refreshUser="$emit('refreshUser')"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';
  import { mapState, mapActions } from 'vuex';
  import MarketplaceController from '@/controllers/MarketplaceController';
  import CollectiblesController from '@/controllers/CollectiblesController';

  export default {
    name: 'Homes',

    components: {
      MarketplaceDesktop: () => import('./MarketplaceDesktop.vue'),
    },

    props: ['isMobile'],

    data: () => ({
      Background,
      listings: null,
      filter: {
        collectible: null,
        rarity: null,
      },
      query: null,
      sort: { date: -1 },
      rarities: [
        { text: 'Common', value: 'common' },
        { text: 'Rare', value: 'rare' },
        { text: 'Epic', value: 'epic' },
        { text: 'Legendary', value: 'legendary' },
        { text: 'GM Instant', value: 'instant' },
        { text: 'GM Lightstick', value: 'special' },
        { text: 'GM Points', value: 'gmp' },
      ],
      artists: [],
    }),

    computed: {
      ...mapState({
        tokens: (state) => state.tokens,
      }),
    },

    mounted() {
      this.getListings();
      this.getCollectibles();
    },

    methods: {
      ...mapActions({ setCollectibles: 'setCollectibles' }),
      filterChanged: function(filter) {
        this.filter = filter;
        this.getListings();
      },
      getCollectibles: async function() {
        try {
          const collectibles = await CollectiblesController.getAllCollectibles();
          this.setCollectibles(collectibles);
          this.artists = [
            ...new Set(collectibles.map((collectible) => collectible.artist)),
          ].filter((artist) => {
            if (artist) {
              return true;
            }
            return false;
          });
          console.log(this.artists);
        } catch (error) {
          this.$emit('handleError', error);
        }
      },
      getListings: async function() {
        try {
          this.listings = await MarketplaceController.getListings(
            this.query,
            this.filter,
            this.sort
          );
        } catch (error) {
          this.$emit('handleError', error);
        }
      },
    },
  };
</script>

<style scoped></style>
